/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
export const autoPlace = (
  button: Element,
  popoverBody: HTMLElement,
): (() => void) => {
  return window.FloatingUIDOM?.autoUpdate(
    button,
    popoverBody,
    () => {
      window.FloatingUIDOM?.computePosition(button, popoverBody, {
        middleware: [
          window.FloatingUIDOM?.autoPlacement({
            allowedPlacements: [
              "top",
              "top-end",
              "top-start",
              "bottom",
              "bottom-end",
              "bottom-start",
            ],
          }),
        ],
      }).then(({ x, y }) => {
        Object.assign(popoverBody.style, {
          left: `${x as number}px`,
          top: `${y as number}px`,
        })
        return
      })
    },
    {
      ancestorScroll: false,
    },
  )
}
